import LineItem, { LineItemProps } from './LineItem';

export type { LineItemProps };
export default LineItem;
